import { render, staticRenderFns } from "./MarkdownList.vue?vue&type=template&id=14a9b960&scoped=true"
import script from "./MarkdownList.vue?vue&type=script&lang=js"
export * from "./MarkdownList.vue?vue&type=script&lang=js"
import style0 from "./MarkdownList.vue?vue&type=style&index=0&id=14a9b960&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a9b960",
  null
  
)

export default component.exports